import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A cut tree stump — a lathe trunk with a flared root base + two FLAT cut-top
// cylinders (cut wood stays a hard flat face — mixed style is correct).
// Rounded art style, plan 28 stage 4.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/stump.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ lathe, cylinder, seed }) => {
    const bark = shade(0x6b4a2b, (rand(seed) - 0.5) * 0.2);
    const h = 0.5 + rand(seed + 1) * 0.4;
    const r = 0.55 + rand(seed + 2) * 0.25;
    // trunk — a revolve that flares into a root buttress at the base and closes
    // just under the cut disc's radius so the flat disc caps the open rim.
    lathe(0, 0, 0, [[r * 1.1, 0], [r * 1.02, h * 0.3], [r * 0.98, h]], bark, 1, 10);
    cylinder(0, h - 0.06, 0, r, r, 0.08, shade(bark, 0.18));          // cut top (rings)
    cylinder(0, h - 0.02, 0, r * 0.4, r * 0.4, 0.06, shade(bark, 0.3)); // heartwood
  };

export default build;
